export default "__VITE_ASSET__DH15pht8__"